// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const Low = "Low";
const Medium = "Medium";
const High = "High";
const VeryHigh = "VeryHigh";
const Absent = "Absent";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const StdInvasiveSpeciesAmountEnum = {
    ...createEnum("StdInvasiveSpeciesAmount", [
        [Low, "Low (< 1m2)"],
        [Medium, "Medium (1m2 - 5m2)"],
        [High, "High (5m2 - 50m2)"],
        [VeryHigh, "Very High (> 50m2)"],
        [Absent, "Absent"],
    ]),
    Low,
    Medium,
    High,
    VeryHigh,
    Absent,
};
null;
null;
export default StdInvasiveSpeciesAmountEnum;
//# sourceMappingURL=StdInvasiveSpeciesAmountEnum.generated.js.map